import type { Payment } from 'paintscout'

export function getPaymentProviderLabel(payment: Payment): string | null {
  if (payment.provider === 'payrix') return 'PaintScout Payments'
  if (payment.provider === 'stripe' || payment.provider === 'stripeW1d') return 'Stripe'
  if (payment.manual) return 'Manual'
  return null
}
